import {
  authenticatedGet,
  authenticatedPost,
  authenticatedPut,
  authenticatedDelete,
} from "../../../api/authenticatedFetch.js";

const BASE = "/api/v1/preventive-actions";

/**
 * GET /api/v1/preventive-actions (optional ?budget_id=) -> { preventive_actions: [...] }
 *
 * budgetId is optional - omit it (or pass null/undefined) to fetch every preventive action
 * for the customer (used by PreventiveActionsPanel, which lists all actions regardless of
 * which budget they're linked to, if any).
 */
export const listPreventiveActions = async (budgetId) => {
  const params = budgetId != null ? { budget_id: budgetId } : {};
  const data = await authenticatedGet(BASE, params);
  return data.preventive_actions || [];
};

/** POST /api/v1/preventive-actions -> { preventive_action: {...} } (201) */
export const createPreventiveAction = async (body = {}) => {
  const data = await authenticatedPost(BASE, body);
  return data.preventive_action;
};

/** PUT /api/v1/preventive-actions/{id} -> { preventive_action: {...} } */
export const updatePreventiveAction = async (id, body = {}) => {
  const data = await authenticatedPut(`${BASE}/${id}`, body);
  return data.preventive_action;
};

/** DELETE /api/v1/preventive-actions/{id} -> 200/204 */
export const deletePreventiveAction = async (id) => {
  await authenticatedDelete(`${BASE}/${id}`);
};
